import React from 'react';
import statusConverter from 'utils/statusConverter';
import { batteryToText } from 'utils/utils';

export const columnSetter = (moduleScn, flag) => {
  const columns = [
    {
      Header: '장치정보',
      columns: [
        {
          Header: 'No',
          accessor: 'rnum',
        },
        {
          Header: '장치명',
          accessor: 'modelNm',
        },
        {
          Header: '위치번호',
          accessor: 'areaNo',
        },
        {
          Header: '위치명',
          accessor: 'areaNm',
        },
      ],
    },
    {
      Header: '측정결과',
      columns: [
        {
          Header: (
            <span>
              불산(ppm)
            </span>
          ),
          accessor: 'h2s',
        },
        {
          Header: (
            <span>
              수소(%LEL)
            </span>
          ),
          accessor: 'h2',
        },
      ],
    },
    {
      Header: '상태정보',
      columns: [
        {
          Header: 'seqnum',
          accessor: 'seqnum',
        },
        {
          id: 'status',
          Header: () => <div>상태</div>,
          Cell: ({ row }) => statusConverter(row.original.status, row.original.statusCode),
        },
        {
          Header: 'rssi',
          accessor: 'rssi',
        },
        // {
        //   Header: 'sf',
        //   accessor: 'sf',
        // },
        // {
        //   Header: 'freqeuncy',
        //   accessor: 'freqeuncy',
        // },
        // {
        //   Header: 'snr',
        //   accessor: 'snr',
        // },
        {
          id: 'Battery',
          Header: () => <div>Battery(%)</div>,
          Cell: ({ row }) => batteryToText(row.original.battery),
        },
        // {
        //   Header: '에러코드',
        //   accessor: 'errorCode',
        // },
        {
          Header: '측정시간',
          accessor: 'regTime',
        },
      ],
    },
  ];

  return columns;
};
